import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useMessage } from "../i18n/locale";

export default function LoadingSpinner({ minHeight = 240, size = 40 }) {
  const loadingLabel = useMessage("loadingContent");

  return (
    <Box
      role="status"
      aria-label={loadingLabel}
      sx={{
        minHeight,
        width: "100%",
        display: "grid",
        placeItems: "center",
      }}
    >
      <CircularProgress size={size} thickness={4} aria-hidden="true" />
    </Box>
  );
}
